import { Component, Input } from '@angular/core';
import { TokenService } from '@app/core/services/token.service';
import { environment } from '@env/environment';
import { IPaginationParams } from '@interfaces';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminPostService, LanguageService } from '@services';
import { TokenUser } from '@shared/interfaces';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-show-comments-like',
  templateUrl: './show-comments-like.component.html',
  styleUrl: './show-comments-like.component.scss',
})
export class ShowCommentsLikeComponent {
  @Input() title!: string;
  @Input() message!: string;
  @Input() data!: any;
  @Input() postId!: string;
  environment: any;
  lang!: string;
  languageSubscription!: Subscription;
  isRTL: boolean = false;
  constructor(
    public activeModal: NgbActiveModal,
    private adminPostService: AdminPostService,
    private _toast: ToastrService,
    private _language: LanguageService,
    private _tokenService: TokenService,
  ) {
    this.environment = environment;
  }
  commentObject: any;
  comment: string = '';
  placeholerText: string = 'comment.value';
  commentIndexTs: number = -1;
  repliesIndexTs: number = -1;
  queryParamSubscription!: Subscription;
  queryParams!: IPaginationParams;
  currentUser!: TokenUser;
  ngOnInit(): void {
    this.languageSubscription = this._language.$langObservable.subscribe((lang) => {
      this.lang = lang;
      if (lang !== 'en') this.isRTL = true;
    });
    this.queryParamSubscription = this.adminPostService.queryParams$.subscribe((params) => (this.queryParams = params));
    this._tokenService.getCurrentUser().subscribe((data: TokenUser) => {
      this.currentUser = data;
    });
  }

  onClose(type: string) {
    this.activeModal.close(type);
  }

  deleteComment(data: any) {
    // const modalRef = this.modalService.open(ConfirmationModalComponent, {
    //   backdrop: 'static',
    //   centered: true,
    // });
    // modalRef.componentInstance.title = 'delete.value';
    // modalRef.result.then((response: string) => {
    //   if (response === 'confirm') {
    this.adminPostService.deleteComment(data).subscribe({
      next: (response) => {
        if (response.status) {
          this._toast.success(response.message);
          if (data.subCommentId) {
            this.data[data.commentIndex].replies.splice(data.repliesIndex, 1);
          } else {
            this.data.splice(data.commentIndex, 1);
          }
        } else {
          this._toast.error(response.message);
        }
      },
      error: (error) => {
        this._toast.error(error);
      },
      complete: () => {
        this.getAllPost();
      },
    });
    // }
    // });
  }

  saveComment(comment: any, commentId?: string) {
    const data = {
      postId: this.postId,
      commentId: !commentId ? comment._id : commentId,
      comment: comment.comment,
      subCommentId: commentId ? comment._id : undefined,
    };
    this.adminPostService.updateComment(data).subscribe({
      next: (response) => {
        if (response.status) {
          this._toast.success(response.message);
        } else {
          this._toast.error(response.message);
        }
      },
      error: (error) => {
        this._toast.error(error);
      },
      complete: () => {
        comment.isEditing = false;
      },
    });
  }

  getAllPost() {
    this.adminPostService.getAllPosts(this.queryParams, this.lang).subscribe({
      next: (response) => {
        if (response.status) {
          this.adminPostService.setPosts(response.data);
        } else {
          this._toast.error(response.message);
        }
      },
      error: (error) => {
        this._toast.error(error);
      },
    });
  }

  setCommentObject(data: any) {
    this.placeholerText = 'reply.value';
    this.commentObject = data;
    this.commentIndexTs = data.commentIndex;
    this.repliesIndexTs = data.repliesIndex;
  }

  sendComment() {
    this.commentObject = {
      ...(this.commentObject
        ? { ...this.commentObject, comment: this.comment }
        : {
            userId: this.currentUser._id,
            postId: this.postId,
            comment: this.comment,
          }),
      userName: 'Nirlat Team',
      profilePic: 'stage/assets/public/logo/logo.png',
      isAdmin: true,
    };
    this.adminPostService.commentOnPost(this.commentObject).subscribe({
      next: (res) => {
        if (res.status) {
          this._toast.success(res.message);
        }
      },
      error: (err) => {
        this._toast.error(err);
      },
      complete: () => {
        this.resetValues();
        this.getComments();
        this.getAllPost();
      },
    });
  }

  getComments() {
    this.adminPostService.getPostComments(this.postId).subscribe({
      next: (res) => {
        if (res.status) {
          this.data = res.data.comments;
        }
      },
      error: (err) => {
        this._toast.error(err.message);
      },
    });
  }

  resetValues() {
    this.commentObject = null;
    this.comment = '';
    this.commentIndexTs = -1;
    this.repliesIndexTs = -1;
  }

  ngOnDestroy() {
    this.queryParamSubscription.unsubscribe();
    this.languageSubscription.unsubscribe();
  }
}
